<span
  class="incorrect-sound-tooltip-container"
  [style.display]="displayOrHide()"
>
  <div class="incorrect-sound-tooltip-container-positioned">
    <div
      class="incorrect-sound-tooltip-text"
      [style.display]="displayOrHide()"
      [style.top.px]="top"
      [style.left.px]="left"
    >
      <input
        class="incorrect-sound-tooltip-text-input"
        [style.display]="displayOrHide()"
        matInput
        [id]="id"
        [formControl]="control"
        type="text"
        maxlength="100"
      />
    </div>
  </div>
</span>
